import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { ISendMessage, IViewMessage } from '../../Types/Message';
import { AppSettings } from '../../Utils/Settings';
export const messageApi = createApi({
    reducerPath: 'messageApi',
    baseQuery: fetchBaseQuery({
        baseUrl: AppSettings.ApiBaseUrl,
        prepareHeaders: async (headers, {getState}) =>{
            headers.set(
                'Authorization',
                `Bearer ${(localStorage.getItem('token') ?? '')}`
            );
            return headers;
        }
    }),
    endpoints: (builder) => ({     
        getMessages: builder.query<IViewMessage[], string>({
            query: (locator) => ({
                url: `/message/${locator}`,
                method: "GET"
            }),
            async onCacheEntryAdded(
              arg,
              { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
            ) {
              // create a websocket connection when the cache subscription starts
              const ws = new WebSocket(`${AppSettings.WebsocketUrl}?user_locator=${arg}&type=message`)
              try {
                // wait for the initial query to resolve before proceeding
                await cacheDataLoaded
      
                // when data is received from the socket connection to the server,
                // update our query result with the received message
                const listener = (event: MessageEvent) => {
                    const { type, data } = JSON.parse(event.data);
                    if (type === 'message' && data.message.length > 0) {
                        updateCachedData((draft) => {
                            const conversation = draft.find( d => d.receiver_locator === data.sender);
                            if (conversation) {
                                conversation.messages.push(data)
                            } else {
                                draft.push({
                                    receiver_locator: data.sender,
                                    receiver_first_name: '',
                                    receiver_last_name: '',
                                    messages: data.message
                                })
                            }
                        })
                    }
                }
      
                ws.addEventListener('message', listener)
              } catch {
                // no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
                // in which case `cacheDataLoaded` will throw
              }
              // cacheEntryRemoved will resolve when the cache subscription is no longer active
              await cacheEntryRemoved
              // perform cleanup steps once the `cacheEntryRemoved` promise resolves
              ws.close()
            },
        }),   
        sendMessage: builder.mutation<{message: string}, ISendMessage>({
            query: (body) => ({
                url: `/message/send`,
                method: "POST",
                body
            })
        }),       
    }),
})

export const {
    useGetMessagesQuery,
    useSendMessageMutation
} = messageApi